/**
 *
 *
 *
 */
import React from 'react';
import { darken, lighten, saturate } from 'polished';
import styled from 'styled-components';
import * as Router from 'react-router-dom';
import Spinner from '../../_components/Spinner';
import T from '../../_components/Typography';
import * as u from '../../utils';


/**
 *
 *
 *
 */
const FRG_CHECK_RESET_TOKEN = `
  query AccountsCheckResetToken($token: String!) {
    accounts_check_reset_token(token: $token)
  }
`;


/**
 *
 *
 *
 */
const FRG_SUBMIT_RESET_PASSWORD = `
  mutation AccountsSubmitResetPassword(
    $token: String!,
    $new_password: String!,
    $repeat_password: String!
  ) {
    accounts_submit_reset_password(
      token: $token,
      new_password: $new_password,
      repeat_password: $repeat_password
    )
  }
`;


/**
 *
 *
 *
 */
export default function Password() {

  const { tkn } = Router.useParams();
  const [ isLoading, setIsLoading ] = React.useState(false);
  const [ error, setError ] = React.useState();
  React.useEffect(() => { onCheckToken(); }, [tkn]);

  return (
    <S.Container>
      <S.TopImage src="/assets/mlx.png" />
      <S.FormContainer onSubmit={onSubmit} method="POST" action="/reset" autoComplete="off">
        <S.SectionContainer>
          <S.SectionTopContainer>
            <T.IL5>New Password</T.IL5>
          </S.SectionTopContainer>
          <S.Input required type="password" name="new_password" autoComplete="off" />
        </S.SectionContainer>
        <S.SectionContainer>
          <S.SectionTopContainer>
            <T.IL5>Repeat Password</T.IL5>
          </S.SectionTopContainer>
          <S.Input required type="password" name="repeat_password" autoComplete="off" />
        </S.SectionContainer>
        {error && (
          <S.SectionContainer>
            <T.IL5 color="red">{error}</T.IL5>
          </S.SectionContainer>
        )}
        <S.Button type="submit">
          {isLoading ? <Spinner /> : <T.IL6 color="white">Submit</T.IL6>}
        </S.Button>
      </S.FormContainer>
    </S.Container>
  );


  /**
   *
   *
   *
   */
  async function onCheckToken() {
    const params = { token: tkn };
    const [data, err] = await u.fetcher(FRG_CHECK_RESET_TOKEN, params);
    if (err) return setError('Invalid token');
    if (!data) return setError('Invalid token');
  }

  /**
   *
   *
   *
   */
  async function onSubmit(evt) {
    evt.preventDefault();
    const currForm = new FormData(evt.target);
    const raw = {};
    for (const [k, v] of currForm.entries()) raw[k] = v;

    const noSame = raw.new_password !== raw.repeat_password;
    if (noSame) return setError('Passwords do not match');

    try {
      setIsLoading(true);
      const params = { token: tkn, ...raw };
      const [data, err] = await u.fetcher(FRG_SUBMIT_RESET_PASSWORD, params);
      if (!data?.status || err) return setError('Something went wrong');
      window.location.href = '/login';
    } catch (err) {
      setError(err.message);
      setIsLoading(false);
    }
  }
}


/**
 *
 *
 *
 */
const S = {};

S.Container = styled.div`
  width: 400px;
  margin: 0px auto;
  padding-bottom: 50px;
  margin-top: 20px;
  @media (max-width: 600px) {
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
  }
`;

S.TopImage = styled.img`
  width: 400px;
  height: 161px;
  object-fit: cover;
  margin-bottom: 50px;
  @media (max-width: 600px) {
    width: 100%;
    height: auto;
    margin-bottom: 20px;
  }
`;

S.FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px;
  border-radius: 6px;
  border: 1px solid rgb(216, 222, 228);
  background: rgb(246, 248, 250);
`;

S.BottomContainer = styled.div`
  display: flex;
  align-content: center;
  justify-content: center;
  flex-wrap: wrap;
  height: 100px;
  width: 100%;
  margin-top: 25px;
  border-radius: 6px;
  border: 1px solid rgb(216, 222, 228);
  p:nth-child(3) {
    &:hover {
      cursor: pointer;
      color: ${lighten(0.1, saturate(0.1, '#FD8C73'))}
    }
  }
`;

S.SectionContainer = styled.div`
  margin-bottom: 20px;
`;

S.SectionTopContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  p:nth-child(2) {
    cursor: pointer;
    &:hover { color: ${lighten(0.1, saturate(0.1, '#FD8C73'))} }
  }
`;

S.Input = styled.input`
  width: 100%;
  height: 40px;
  border: 1px solid rgb(208, 215, 222);
  border-radius: 6px;
  padding-left: 6px;
  font-family: 'Inter';
  font-size: 14px;
`;

S.Label = styled.label`
  display: block;
  margin-bottom: 5px;
`;

S.Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  border-radius: 6px;
  background: ${p => p.$color || p.theme.accent};
  border: 1px solid ${p => p.$color || 'rgba(31, 35, 40, 0.15)'};
  &:hover { cursor: pointer; background: ${p => darken(0.1, (p.$color || p.theme.accent))}; }
`;
